import { useSelector } from 'react-redux';

export function useTimerData(timerId) {
  return useSelector(state => state.timers[timerId] || {});
}